export type QuizLevel = "beginner" | "intermediate" | "advanced";

export interface QuizQuestion {
  id: string;
  text: string;
  choices: string[];
  correctIndex: number;
  explanation: string;
}

export interface Quiz {
  id: string;
  title: string;
  questions: QuizQuestion[];
  level: QuizLevel;
  duration: number;
}

const quizBiaisQuestions: QuizQuestion[] = [
  {
    id: "q1",
    text: "Le biais de confirmation consiste a :",
    choices: [
      "Chercher des infos qui contredisent nos idees",
      "Chercher des infos qui confirment nos idees",
      "Toujours changer d'avis",
      "Ignorer toutes les preuves",
    ],
    correctIndex: 1,
    explanation: "On retient surtout ce qui valide ce qu'on pense deja.",
  },
  {
    id: "q2",
    text: "Quel geste aide a le limiter ?",
    choices: [
      "Lire uniquement des sources proches de soi",
      "Chercher volontairement un avis oppose",
      "Eviter toute discussion",
      "Se fier aux titres seulement",
    ],
    correctIndex: 1,
    explanation: "Confronter ses idees avec des sources opposees reduit le biais.",
  },
  // TODO MixMind: ajouter les 8 autres questions du quiz editoriel (Lyra) pour atteindre 10 QCM.
];

const quizBiaisConfirmation: Quiz = {
  id: "quiz_biais_confirmation",
  title: "Quiz - Biais de confirmation",
  level: "intermediate",
  duration: 5,
  questions: quizBiaisQuestions,
};

const quizAliases: Quiz[] = [
  {
    ...quizBiaisConfirmation,
    id: "quiz-biais-1",
    level: "beginner",
  },
];

export const demoQuizzes: Quiz[] = [quizBiaisConfirmation, ...quizAliases];

export const allQuizzes: Quiz[] = [...demoQuizzes];
